(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["cc-mayoreo"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__ccPdpMayoreo) return;
    window.__ccPdpMayoreo = true;

    function whenCCM(fn) {
      if (window.CCM) fn(window.CCM);
      else setTimeout(function () { whenCCM(fn); }, 40);
    }

    function formFor(pid) {
      return document.querySelector('product-form-component[data-product-id="' + pid + '"]');
    }

    function selectedQty(pid) {
      var f = formFor(pid);
      var input = f && f.querySelector('input[name="quantity"]');
      return Math.max(1, parseInt(input && input.value, 10) || 1);
    }

    function selectedVariant(pid) {
      var f = formFor(pid);
      var input = f && f.querySelector('input[name="id"]');
      return input ? input.value : null;
    }

    function setMainPrice(block, CCM, unit, base, active) {
      if (block.dataset.highlightPrice !== 'true') return;
      var pid = block.dataset.productId;
      document.querySelectorAll('product-price[data-product-id="' + pid + '"]').forEach(function (pp) {
        var priceEl = pp.querySelector('.price');
        if (!priceEl) return;
        var was = pp.querySelector('.cc-main-was');
        var tag = pp.querySelector('.cc-main-tag');
        if (active) {
          if (!priceEl.dataset.ccOrig) priceEl.dataset.ccOrig = priceEl.textContent;
          var txt = CCM.fmt(unit);
          if (priceEl.textContent !== txt) priceEl.textContent = txt;
          if (!was) {
            was = document.createElement('s');
            was.className = 'cc-main-was';
            priceEl.insertAdjacentElement('afterend', was);
          }
          if (was.textContent !== CCM.fmt(base)) was.textContent = CCM.fmt(base);
          if (!tag) {
            tag = document.createElement('span');
            tag.className = 'cc-main-tag';
            tag.textContent = 'Mayoreo';
            was.insertAdjacentElement('afterend', tag);
          }
        } else {
          if (priceEl.dataset.ccOrig && priceEl.textContent !== priceEl.dataset.ccOrig) priceEl.textContent = priceEl.dataset.ccOrig;
          if (was) was.remove();
          if (tag) tag.remove();
        }
      });
    }

    function update(block, CCM) {
      var cfg = block.__ccm || (block.__ccm = CCM.parse(block.dataset.ccM));
      if (!cfg || !cfg.t || !cfg.t.length) return;
      var pid = block.dataset.productId;
      var prices = block.__prices;
      if (!prices) {
        try { prices = block.__prices = JSON.parse(block.querySelector('[data-cc-variant-prices]').textContent); }
        catch (e) { prices = block.__prices = {}; }
      }
      var vid = selectedVariant(pid);
      var base = (vid && prices[vid]) || parseInt(block.dataset.ccBase, 10) || 0;
      var inCart = CCM.qty(cfg.g);
      var qty = selectedQty(pid);
      var total = inCart + qty;
      var idx = CCM.tierIndex(cfg, total);
      var unit = CCM.unit(cfg, base, total);

      var firstMax = block.querySelector('[data-cc-first-max]');
      if (firstMax) firstMax.textContent = cfg.t[0][0] - 1;
      block.querySelectorAll('[data-cc-row]').forEach(function (row) {
        var i = +row.dataset.ccRow;
        row.classList.toggle('is-active', i === idx);
        var p = i < 0 ? base : CCM.tierPrice(cfg, base, i);
        var pe = row.querySelector('[data-cc-row-price]');
        if (pe) pe.textContent = CCM.fmt(p);
        var se = row.querySelector('[data-cc-row-save]');
        if (se) se.textContent = base - p > 0 ? '−' + CCM.fmt(base - p) : '—';
      });

      var unitEl = block.querySelector('[data-cc-live-unit]');
      var wasEl = block.querySelector('[data-cc-live-was]');
      var textEl = block.querySelector('[data-cc-live-text]');
      var bar = block.querySelector('[data-cc-bar]');
      if (unitEl) unitEl.textContent = CCM.fmt(unit);
      if (wasEl) {
        wasEl.hidden = !(unit < base);
        wasEl.textContent = CCM.fmt(base);
      }
      block.classList.toggle('is-on', idx > -1);

      var nx = CCM.next(cfg, base, total);
      var msg = [];
      if (inCart > 0) msg.push(inCart + ' en tu carrito + ' + qty + ' seleccionada' + (qty > 1 ? 's' : '') + ' = ' + total + ' pzas');
      else msg.push(qty + ' pza' + (qty > 1 ? 's' : '') + ' seleccionada' + (qty > 1 ? 's' : ''));
      if (idx > -1) msg.push('✓ Precio mayoreo aplicado (' + CCM.fmt(unit) + ' c/u · total ' + CCM.fmt(unit * qty) + ')');
      if (nx) msg.push('Agrega ' + nx.need + ' pza' + (nx.need > 1 ? 's' : '') + ' más para pagar ' + CCM.fmt(nx.price) + ' c/u');
      else if (idx > -1) msg.push('¡Tienes el mejor precio!');
      if (textEl) textEl.textContent = msg.join(' · ');

      if (bar) {
        var target = nx ? nx.min : cfg.t[cfg.t.length - 1][0];
        var prev = idx > -1 ? cfg.t[idx][0] : 0;
        var pct = nx ? ((total - prev) / Math.max(1, target - prev)) * 100 : 100;
        bar.style.width = Math.max(4, Math.min(100, pct)) + '%';
      }

      setMainPrice(block, CCM, unit, base, idx > -1);
    }

    function updateAll() {
      if (!window.CCM) return;
      document.querySelectorAll('[data-cc-pdp]').forEach(function (b) { update(b, window.CCM); });
    }

    var raf;
    function schedule(delay) {
      clearTimeout(raf);
      raf = setTimeout(updateAll, delay || 0);
    }

    whenCCM(function (CCM) {
      if (!document.querySelector('[data-cc-pdp]')) return;
      CCM.on(updateAll);

      document.addEventListener('quantity-selector:update', function () { schedule(0); });
      document.addEventListener('variant:update', function () { schedule(60); });
      document.addEventListener('input', function (e) {
        if (e.target && e.target.name === 'quantity') schedule(0);
      });
      document.addEventListener('change', function (e) {
        if (e.target && (e.target.name === 'quantity' || e.target.name === 'id')) schedule(0);
      });
      document.addEventListener('click', function (e) {
        if (e.target.closest && e.target.closest('.quantity-plus, .quantity-minus')) schedule(30);
      });

      document.querySelectorAll('product-price').forEach(function (pp) {
        new MutationObserver(function () { schedule(20); }).observe(pp, { childList: true, subtree: true });
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
